"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectValidator = void 0;
const ramda_1 = require("ramda");
const provider_1 = require("./provider");
const utils_1 = require("./utils");
const validator_1 = require("./validator");
class ObjectValidator extends validator_1.CommonValidator {
    getAllPossibleInterpretations() {
        const { interpretations = [], properties = {} } = this.props;
        const out = interpretations.slice();
        for (const item of Object.values(properties)) {
            out.push(...item.getAllPossibleInterpretations());
        }
        return out;
    }
    getAllPossibleTags() {
        const { tags = [], properties = {} } = this.props;
        const out = tags.slice();
        for (const item of Object.values(properties)) {
            out.push(...item.getAllPossibleTags());
        }
        return out;
    }
    merge(props) {
        return new ObjectValidator(mergeProps(this.props, props));
    }
    sealed(sealed = true) {
        return this.merge({ sealed });
    }
    properties(properties) {
        return this.merge({ properties });
    }
    getPropsToLog() {
        return (0, ramda_1.dissoc)("properties", super.getPropsToLog());
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [
                this.validateType,
                this.validateProperties,
                this.validateSealed
            ]
        });
    };
    validateType = async ({ ctx, next }) => {
        if (typeof ctx.value === "object" &&
            ctx.value !== null &&
            !Array.isArray(ctx.value)) {
            return next();
        }
        ctx.addError({ type: "object" });
    };
    validateProperties = async ({ rootCtx, ctx, next, options }) => {
        const { properties } = this.props;
        if (properties === undefined) {
            return next();
        }
        let value = ctx.value;
        for (const [key, item] of Object.entries(properties)) {
            const itemCtx = ctx.createChild(key);
            if ((0, provider_1.isProvider)(item)) {
                itemCtx.value = (await item.evaluate({ rootCtx, ctx: itemCtx }))[1];
                item.logProps({ ctx: itemCtx });
                if (itemCtx.value !== value[key] || !(key in value)) {
                    if (value === ctx.value) {
                        value = { ...value };
                    }
                    value[key] = itemCtx.value;
                }
            }
            else {
                await item.entry({ rootCtx, ctx: itemCtx, options });
                if (itemCtx.value !== value[key]) {
                    if (value === ctx.value) {
                        value = { ...value };
                    }
                    value[key] = itemCtx.value;
                }
            }
            ctx.transferData(itemCtx);
            ctx.mergeLogItems(itemCtx);
        }
        if (value !== ctx.value) {
            ctx.value = value;
        }
        return next();
    };
    validateSealed = async ({ rootCtx, ctx, next }) => {
        const { properties } = this.props;
        if (properties === undefined) {
            return next();
        }
        const sealed = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.sealed);
        if (sealed !== true) {
            return next();
        }
        const unknownProperties = getAdditionalProperties(ctx.value, properties);
        if (unknownProperties.length === 0) {
            return next();
        }
        for (const key of unknownProperties) {
            const itemCtx = ctx.createChild(key);
            itemCtx.addError({ presence: "forbidden" });
            ctx.mergeLogItems(itemCtx);
        }
    };
}
exports.ObjectValidator = ObjectValidator;
function mergeProps(propsA, propsB) {
    const propsC = { ...propsA, ...propsB };
    if (propsA.properties !== undefined && propsB.properties !== undefined) {
        propsC.properties = { ...propsA.properties, ...propsB.properties };
    }
    return propsC;
}
function getAdditionalProperties(value, properties) {
    return Object.keys(value).filter(key => !(key in properties));
}
